<template>
    <div style="height: calc(100vh - 100px);overflow: scroll; padding: 10px">

        <div>
            <v-breadcrumbs>
                <v-icon slot="divider" color="#68718e">play_arrow</v-icon>
                <v-breadcrumbs-item>
                    <a @click="goBack">
                        <span style="color: #515a75"> Settings</span>
                    </a>
                </v-breadcrumbs-item>
                <v-breadcrumbs-item>
                    <span style="color: #515a75">Knowledgebase Folder</span>
                </v-breadcrumbs-item>
            </v-breadcrumbs>
        </div>
        <div class="elc-card-main" v-if="!loader">
            <v-card class="p-10">
                <v-layout wrap row>
                    <v-flex xs10 md11>
                        <p style="font-weight:500; font-size:22px; color: #596363; margin: 0; margin-top: 17px">
                            Knowledge Base Folder</p>
                    </v-flex>

                    <v-flex xs2 md1 class="text-xs-right">
                        <div class="p-l-10 p-r-10">
                            <v-tooltip bottom>
                                <v-btn fab small slot="activator" class="elc-button-rounded" @click="addKBFolderDialog">
                                    <v-icon dark style="margin-top: -5px">add</v-icon>
                                </v-btn>
                                <span>Add Folder</span>
                            </v-tooltip>
                        </div>
                    </v-flex>
                </v-layout>
                <div class="p-t-16 p-b-16">

                    <v-layout row wrap>
                        <v-flex xs8 md8 style="font-size: 18px">
                            Name
                        </v-flex>
                        <v-flex xs4 md4 class="text-xs-right p-r-10" style="font-size: 17px">
                            Actions
                        </v-flex>
                        <v-flex xs12>
                            <div class="p-t-10 p-b-10">
                                <v-treeview
                                        v-model="tree"
                                        :open="open"
                                        :items="folderArr"
                                        item-key="name"
                                        item-children="childrenArr"
                                        class="elc-treeview"
                                >
                                    <template slot="label" slot-scope="{ item, open, leaf }">
                                        <span v-if="!leaf">  **{{item.name}}</span>
                                        <v-card style="height:50px"  v-if="leaf">
                                            **{{item.name}}
                                        </v-card>
                                    </template>
                                    <template slot="prepend" slot-scope="{ item, open, leaf }">
                                        <v-icon>
                                            {{ open ? 'folder_open' : 'folder' }}
                                        </v-icon>
                                    </template>

                                    <template slot="append" slot-scope="{ item, open, leaf }">
                                        <v-tooltip style="padding: 0 5px" slot="activator" bottom>
                                            <v-icon style="font-size: 16px"
                                                    slot="activator" @click="addSubKBFolderDialog(item)" small>
                                                add
                                            </v-icon>
                                            <span>Add Folder</span>
                                        </v-tooltip>
                                        <v-tooltip style="padding: 0 5px" slot="activator" bottom>
                                            <v-icon style="font-size: 16px"
                                                    slot="activator" @click="editKBFolderDialog(item)" small>
                                                {{'edit' }}
                                            </v-icon>
                                            <span>Edit Folder</span>
                                        </v-tooltip>
                                        <v-tooltip style="padding: 0 5px" slot="activator" bottom
                                                   :disabled="!leaf">
                                            <!--:disabled="item.childrenArr"-->
                                            <v-icon style="font-size: 16px"
                                                    slot="activator" :disabled="!leaf"
                                                    @click="openDelDialog(item)"
                                                    small>
                                                {{'delete' }}
                                            </v-icon>
                                            <span>Delete Folder</span>
                                        </v-tooltip>
                                    </template>
                                </v-treeview>
                            </div>
                        </v-flex>
                    </v-layout>
                    <div>

                    </div>
                </div>

            </v-card>
        </div>

        <v-dialog v-model="KBFolderDialog" persistent @keydown.esc="KBFolderDialog=false" width="300px">
            <v-form v-model="valid" lazy-validation ref="form">

                <v-card>
                    <div class="p-10">

                        <div style="position:relative;">
                            <h2 class="p-10" v-if="!addEditFlag">Add Folder </h2>
                            <h2 class="p-10" v-else>Update Folder </h2>
                            <v-tooltip bottom style="position:absolute;top: 0;right: 0;">

                                <v-btn slot="activator" icon @click="KBFolderDialog=false">
                                    <v-icon>clear</v-icon>
                                </v-btn>

                                <span>Close</span>

                            </v-tooltip>
                        </div>
                        <v-layout wrap>
                            <v-flex xs12 class="p-10">
                                <v-text-field v-model="folder.name" :rules="fieldRules" label="Name*"
                                              v-if="KBFolderDialog" autofocus required></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-flex xs12 class="text-sm-right">
                            <v-btn class="elc-button-radius" @click="KBFolderDialog=false">Cancel</v-btn>

                            <v-btn class="elc-button-radius-color" v-if="!addEditFlag"
                                   :disabled="folder.name === '' || !valid" @click="addFolder(folderData)">Save
                            </v-btn>
                            <v-btn class="elc-button-radius-color" v-else
                                   :disabled="folder.name === '' || !valid" @click="updateFolder">Update
                            </v-btn>
                        </v-flex>

                    </div>
                </v-card>
            </v-form>
        </v-dialog>
        <loader v-if="loader"></loader>
        <alert-modal :alertMsg="msg" :alertMsgDialog="alertDialog" @closeAlert="alertDialog = false"></alert-modal>
        <v-dialog v-model="delDialog" persistent max-width="290">
            <v-card>
                <v-card-text>Are you sure you want to delete this folder?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="elc-button-radius" flat @click.native="delDialog = false">Cancel</v-btn>
                    <v-btn class="elc-button-radius-color" flat @click.native="deleteFolder()">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import Common from '../Common/Constants'
    import axios from 'axios'
    import AlertModal from '../Common/AlertModal'
    import Vue from 'vue'
    import Loader from '../Common/Loader.vue'

    export default {
        name: "KnowledgeBaseFolder",
        components: {AlertModal, Loader},
        data() {
            return {
                filterValue: '',
                constant: Common,
                valid: false,
                loader: false,
                alertDialog: false,
                msg: '',
                delDialog: false,
                delData: {},
                fieldRules: [
                    v => !!v || 'This field is required',
                    (v) => {
                        if (!v || v.length <= 3)
                            return 'Must be greater than 3 characters';
                        else return true;
                    },
                ],
                folderArr: [],
                KBFolderDialog: false,
                addEditFlag: false,
                addSubFolderFlag: false,
                folder: {
                    name: '',
                    parentId: '',
                },
                folderData: {},
                open: [],
                tree: [],

                /*props: {
                    stripe: false,
                    border: false,
                    showHeader: true,
                    showSummary: false,
                    showRowHover: true,
                    showIndex: false,
                    treeType: true,
                    isFold: true,
                    expandType: true,
                    selectionType: false,
                },
                data: [
                    {
                        name: 'Jack',
                        sex: 'male',
                        likes: ['football', 'basketball'],
                        score: 10,
                        action: 'abc',
                        children: [
                            {
                                name: 'Ashley',
                                sex: 'female',
                                likes: ['football', 'basketball'],
                                score: 20,

                                children: [
                                    {
                                        name: 'Ashley',
                                        sex: 'female',
                                        likes: ['football', 'basketball'],
                                        score: 20,
                                    },
                                    {
                                        name: 'Taki',
                                        sex: 'male',
                                        likes: ['football', 'basketball'],
                                        score: 10,
                                        children: [
                                            {
                                                name: 'Ashley',
                                                sex: 'female',
                                                likes: ['football', 'basketball'],
                                                score: 20,
                                            },
                                            {
                                                name: 'Taki',
                                                sex: 'male',
                                                likes: ['football', 'basketball'],
                                                score: 10,
                                                children: [
                                                    {
                                                        name: 'Ashley',
                                                        sex: 'female',
                                                        likes: ['football', 'basketball'],
                                                        score: 20,
                                                    },
                                                    {
                                                        name: 'Taki',
                                                        sex: 'male',
                                                        likes: ['football', 'basketball'],
                                                        score: 10,
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                name: 'Taki',
                                sex: 'male',
                                likes: ['football', 'basketball'],
                                score: 10,
                            },
                        ],
                    },
                    {
                        name: 'Tom',
                        sex: 'male',
                        likes: ['football', 'basketball'],
                        score: 20,
                        action: 'abc',
                        children: [
                            {
                                name: 'Ashley',
                                sex: 'female',
                                likes: ['football', 'basketball'],
                                score: 20,
                                children: [
                                    {
                                        name: 'Ashley',
                                        sex: 'female',
                                        likes: ['football', 'basketball'],
                                        score: 20,
                                    },
                                    {
                                        name: 'Taki',
                                        sex: 'male',
                                        likes: ['football', 'basketball'],
                                        score: 10,
                                    },
                                ],
                            },
                            {
                                name: 'Taki',
                                sex: 'male',
                                likes: ['football', 'basketball'],
                                score: 10,
                                children: [
                                    {
                                        name: 'Ashley',
                                        sex: 'female',
                                        likes: ['football', 'basketball'],
                                        score: 20,
                                    },
                                    {
                                        name: 'Taki',
                                        sex: 'male',
                                        likes: ['football', 'basketball'],
                                        score: 10,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        name: 'Tom',
                        sex: 'male',
                        likes: ['football', 'basketball'],
                        action: 'abc',
                        score: 20,
                    },
                    {
                        name: 'Tom',
                        sex: 'male',
                        likes: ['football', 'basketball'],
                        score: 20,
                        action: 'abc',
                        children: [
                            {
                                name: 'Ashley',
                                sex: 'female',
                                likes: ['football', 'basketball'],
                                score: 20,
                            },
                            {
                                name: 'Taki',
                                sex: 'male',
                                likes: ['football', 'basketball'],
                                score: 10,
                            },
                        ],
                    },
                ],
                columns: [
                    {
                        label: 'name',
                        prop: 'name',
                        width: '400px',
                    },
                    {
                        label: 'sex',
                        prop: 'sex',
                        minWidth: '50px',
                    },
                    {
                        label: 'score',
                        prop: 'score',
                    },
                    {
                        label: 'likes',
                        prop: 'likes',
                        minWidth: '200px',
                        type: 'template',
                        template: 'likes',
                    },
                    {
                        label: 'Actions',
                        prop: 'action',
                    },
                ],

                columns1: [
                    {
                        property: 'firstName',
                        title: 'First Name',
                        direction: null,
                        filterable: true,
                        visible: true,
                        collapseIcon: true,
                    },
                    {
                        property: 'lastName',
                        title: 'Last Name',
                        direction: null,
                        filterable: true,
                        visible: true,
                        collapseIcon: true,
                    },
                ],
                rows1: [
                    {
                        firstName: 'Albert',
                        lastName: 'Einstein',
                        _showChildren: false,
                        _children: [
                            {
                                firstName: 'Abc',
                                lastName: 'Abc',

                            },
                            {
                                firstName: 'DEF',
                                lastName: 'DEF',
                            },
                        ],
                    },
                    {
                        firstName: 'Barack',
                        lastName: 'Obama',
                    },
                ],


                col: [
                    {
                        property: 'name',
                        title: 'Name',
                        direction: null,
                        filterable: true,
                        visible: true,
                        collapseIcon: true,
                    },
                    {
                        property: 'id',
                        title: 'Actions',
                        direction: null,
                        filterable: true,
                        visible: true,
                        collapseIcon: false,
                    },
                ],*/
                /* pagination: {},
                 totalItems: 2,
                 items: [
                     {
                         id: 1,
                         name: "Node 1",
                         description: "Root Node With Children",
                         depth: 1,
                         children: [
                             {
                                 id: 3,
                                 name: "Node 1.1",
                                 description: "Child of Root",
                                 depth: 2,
                                 leaf: true,
                             },
                             {
                                 id: 4,
                                 name: "Node 1.2",
                                 description: "Child of Root",
                                 depth: 2,
                                 children: [
                                     {
                                         id: 5,
                                         name: "Node 1.2.1",
                                         description: "Child of 1.2",
                                         depth: 3,
                                         leaf: true,
                                     },
                                     {
                                         id: 6,
                                         name: "Node 1.2.2",
                                         description: "Child of 1.2",
                                         depth: 3,
                                         leaf: true,
                                     }
                                 ]
                             }
                         ]
                     },
                     {
                         id: 2,
                         name: "Node 2",
                         description: "Root Node No Children",
                         depth: 1,
                         leaf: true,
                     }
                 ],
                 headers: [
                     {
                         text: "Name",
                         value: "name"
                     },
                     {
                         text: "Description",
                         value: "description"
                     }
                 ],*/

            }
        },
        computed: {
            /* propList() {
                 return Object.keys(this.props).map(item => ({
                     name: item,
                 }));
             },*/
        },
        created() {
            this.getFolder();
        },
        methods: {
            getFolder() {
                let self = this;
                self.loader = true;
                self.folderArr = [];
                self.msg = '';
                // axios.get(self.constant.apiUrl + 'getBookMarkFolder')
                axios.get(self.constant.apiUrl + 'getKnowledgeBaseCollectionFolderHierarchy')
                    .then(response => {
                        if (response.data.flag) {
                            response.data.data.forEach(function (val) {
                                if (val.childrenArr) {
                                    val._children = val.childrenArr;
                                    val._showChildren = false;

                                }
                            });
                            self.folderArr = response.data.data;
                            console.log(self.folderArr)
                            self.loader = false;
                        } else {
                            self.loader = false;
                            self.alertDialog = true;
                            self.msg = response.data.message;
                        }
                    })
            },
            addKBFolderDialog() {
                let self = this;
                self.folder = {};
                self.addEditFlag = false;
                self.addSubFolderFlag = false;
                self.KBFolderDialog = true;
            },
            addSubKBFolderDialog(data) {
                let self = this;
                self.folder = {};
                self.folderData = data;
                self.addEditFlag = false;
                self.addSubFolderFlag = true;
                self.KBFolderDialog = true;
            },
            addFolder(data) {
                let self = this;
                let request = {
                    "name": self.folder.name,
                    "parentId": self.addSubFolderFlag ? data.id : ""
                };
                console.log("request", request)
                if (self.valid) {
                    axios.post(self.constant.apiUrl + 'addBookMarkFolder', request)
                        .then(res => {
                            console.log(res)
                            if (res.data.flag) {
                                self.getFolder();
                                self.$toasted.show('Folder Added', self.constant.successToast);
                            }
                            else {
                                self.alertDialog = true;
                                self.msg = '';
                                self.msg = res.data.message;
                            }
                            self.KBFolderDialog = false;
                        })
                        .catch((handle) => {
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = handle;
                            self.KBFolderDialog = false;
                        })
                } else {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = "Please fill valid details";
                    self.KBFolderDialog = false;
                }
            },
            editKBFolderDialog(data) {
                let self = this;
                self.folder = {};
                self.folder.name = data.name;
                self.folder.parentId = data.parentId;
                self.folder.id = data.id;
                self.addEditFlag = true;
                self.KBFolderDialog = true;
            },
            updateFolder() {
                let self = this;
                let request = {
                    "name": self.folder.name,
                    "parentId": self.addSubFolderFlag ? self.folder.parentId : ''
                };
                axios.put(self.constant.apiUrl + 'updateBookMarkFolder/' + self.folder.id, request)
                    .then(res => {
                        if (res.data.flag) {
                            self.getFolder();
                            self.$toasted.show('Folder Updated', self.constant.successToast);
                        }
                        else {
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = res.data.message;
                        }
                        self.KBFolderDialog = false;
                    })
                    .catch((handle) => {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = handle;
                        self.KBFolderDialog = false;
                    });
            },

            openDelDialog(data) {
                let self = this;
                self.delDialog = true;
                self.delData = {};
                self.delData = data;
            },
            deleteFolder() {
                let self = this;
                axios.delete(self.constant.apiUrl + 'deleteBookMarkFolder/' + self.delData.id)
                    .then(function (res) {
                        if (res.data.flag) {
                            self.getFolder();
                            self.$toasted.show('Folder Deleted', self.constant.successToast);
                        }
                        else {
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = res.data.message;
                        }
                        self.delDialog = false
                    })
                    .catch((handle) => {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = handle;
                        self.delDialog = false
                    });

            },
            goBack() {
                window.history.go(-1)
            },
            /*filterChange(filter) {
               this.filterValue = filter;
           },*/
        }
    }


</script>

<!-- <vue-ads-table-tree
         :columns="columns1"
         :rows="rows1"
         :filter="filterValue"
         @filter-change="filterChange"
 >

     <template slot="title">
         <h2>
             Folder
         </h2>
     </template>
     <template slot="name" slot-scope="props">
         {{props.row.name}}
     </template>
     <template slot="lastName" slot-scope="props">
         {{props.row.lastName}}
         <v-icon v-if="props.row._children" @click="abc">add</v-icon>
     </template>
     <template slot="_children" slot-scope="props">
         <template slot="name" slot-scope="props">
             {{props.row.name}}
         </template>
         <template slot="lastName" slot-scope="props">
             {{props.row.lastName}}
             <v-icon @click="abc">delete</v-icon>
         </template>
     </template>
     <template slot="filter">
         &lt;!&ndash;<h3 class="inline pr-2">Filter:</h3>&ndash;&gt;
         <input
                 v-model="filterValue"
                 class="appearance-none border py-2 px-3"
                 type="text"
                 placeholder="Filter..."
         >
     </template>
 </vue-ads-table-tree>-->
<!-- <vue-ads-table-tree
         :columns="col"
         :rows="folderArr"
         :filter="filterValue"
         @filter-change="filterChange"
 >
     <template slot="title">
         <h2>
             Folder
         </h2>
     </template>
     <template slot="firstName" slot-scope="props">
         {{props.row.firstName}}
     </template>
     <template slot="id" slot-scope="props">
         <v-icon @click="abc">add</v-icon>
     </template>
     <template slot="filter">
         <h3 class="inline pr-2">Filter:</h3>
         <input
                 v-model="filterValue"
                 type="text"
                 placeholder="Filter..."
         >
     </template>
 </vue-ads-table-tree>-->
<!-- <v-tree-data-table :items="items"
                    :headers="headers"
                    :totalItems="totalItems"
                    :loading="false"
                    :pagination="pagination"
                    v-model="selected" :rows-per-page-text="12212"
                    :rows-per-page-items="1"
                    no-data-text="No clubs available"
 >

 </v-tree-data-table>-->
<!-- <v-tree-data-table :headers="headers" :items="items" :pagination="pagination" :loading="false"
                    :total-items="totalItems">
     <template slot="items" slot-scope="props">
         <td>{{props.item.name}}</td>
         <td>{{props.item.description}}</td>
     </template>
 </v-tree-data-table>-->
<!--   <zk-table
           ref="table"
           sum-text="sum"
           index-text="#"
           :data="data"
           :columns="columns"
           :stripe="props.stripe"
           :border="props.border"
           :show-header="props.showHeader"
           :show-summary="props.showSummary"
           :show-row-hover="props.showRowHover"
           :show-index="props.showIndex"
           :tree-type="props.treeType"
           :is-fold="props.isFold"
           :expand-type="props.expandType"
           :selection-type="props.selectionType">
       <template slot="$expand" scope="scope">
           {{ `My name is ${scope.row.name},
           this rowIndex is ${scope.rowIndex}.`
           }}
       </template>
       <template slot="likes" scope="scope">
           {{ scope.row.likes.join(',') }}
       </template>
       <template slot="action" scope="scope">
           {{ scope.row.action }}<v-icon @click="abc">add</v-icon>
       </template>

   </zk-table>-->


// WEBPACK FOOTER //
// src/components/Settings/KnowledgeBaseFolder.vue